(ns quuppa.qsm.planner.background
  (:require [re-frame.core :as rf]
            [reagent.core :as r]
            [quuppa.qsm.planner.events :as e]
            [quuppa.qsm.planner.subs :as su]
            [quuppa.ui.icons :refer [icon]]
            [quuppa.components :as c]))

(defn get-background-image-asset
  "Searches the IMDF data for a siteresource-backgroundimage with the given background-id.
   Returns the map if found, nil otherwise."
  [imdf-data background-id]
  (some (fn [[_ building]]
          (some (fn [[_ level]]
                  (get-in level [:siteresource-backgroundimages background-id]))
                (:levels building)))
        (:buildings (:venue imdf-data))))

(defn get-first-background-for-level
  "Gets the first background image asset for a given level-id.
   Returns [background-id background-asset] or nil if not found."
  [imdf-data level-id]
  (some (fn [[_ building]]
          (when-let [level (get-in building [:levels level-id])]
            (first (:siteresource-backgroundimages level))))
        (:buildings (:venue imdf-data))))

(defn background-image-editor [plan-id building-id level-id open?-atom]
  (r/with-let [pending-file (r/atom nil)
               on-success! #(reset! open?-atom false)]
              [:<>
               [:div.mb-3
                [:label.form-label "Upload floorplan image"]
                [c/file-upload-component
                 {:onupdatefiles (fn [files]
                                   (reset! pending-file (some-> files first .-file)))
                  :labelIdle "Drop floorplan image here or click to browse"}]]
               [:button.btn.btn-sm.btn-primary
                {:disabled (nil? @pending-file)
                 :on-click (fn []
                             (when @pending-file
                               (rf/dispatch [::e/add-background-to-level
                                             plan-id building-id level-id @pending-file on-success!])))}
                "Upload & Add"]]))

(defn background-images-list
  "Shows all background images for the current level, sorted by sort-order.
   Top of list = front (highest z-index). ▲ = bring forward, ▼ = send backward."
  [plan-id building-id level-id open?-atom]
  (let [all-level-bgs @(rf/subscribe [::su/level-background-images plan-id building-id level-id])
        selected-bg-id @(rf/subscribe [:nav/match :parameters :query :background-id])
        plan          @(rf/subscribe [::su/site-plan plan-id])
        resolved-building-id (or building-id
                                 (some (fn [[bid building]]
                                         (when (get-in building [:levels level-id]) bid))
                                       (get-in plan [:imdf :venue :buildings])))
        display-bgs   (vec (reverse all-level-bgs))
        total         (count display-bgs)]
    [:div
     [:label.form-label.mb-1 "Layers"]
     [:div.text-muted.mb-2 {:style {:font-size "11px"}}
      "Top of list = front. Click a layer to select it."]
     (if (empty? all-level-bgs)
       [:p.text-muted.small "No background images yet."]
       [:div {:style {:display "flex" :flex-direction "column" :gap "4px"}}
        (for [[ui-idx [bg-id bg-asset]] (map-indexed vector display-bgs)]
          (let [selected?    (= bg-id selected-bg-id)
                layer-name   (or (:name bg-asset) (str "Layer " (- total ui-idx)))
                is-front?    (zero? ui-idx)
                is-back?     (= ui-idx (dec total))]
            [:div {:key bg-id
                   :style {:display "flex"
                           :align-items "center"
                           :gap "6px"
                           :padding "5px 8px"
                           :border-radius "4px"
                           :background (if selected? "#dbeafe" "#f8f9fa")
                           :border (if selected? "1px solid #93c5fd" "1px solid #dee2e6")
                           :cursor "pointer"}}
             [:div {:style {:display "flex" :flex-direction "column" :gap "1px"}}
              [:button.btn.btn-sm
               {:title    "Bring forward"
                :style    {:padding "0 5px" :line-height "1.2" :font-size "11px"
                           :opacity (if is-front? "0.25" "1")}
                :disabled is-front?
                :on-click (fn [e]
                            (.stopPropagation e)
                            (rf/dispatch [::e/move-background-order
                                          {:background-id bg-id
                                           :direction     :down
                                           :plan-id       plan-id
                                           :building-id   resolved-building-id
                                           :level-id      level-id}]))}
               [icon :chevron-up]]
              [:button.btn.btn-sm
               {:title    "Send backward"
                :style    {:padding "0 5px" :line-height "1.2" :font-size "11px"
                           :opacity (if is-back? "0.25" "1")}
                :disabled is-back?
                :on-click (fn [e]
                            (.stopPropagation e)
                            (rf/dispatch [::e/move-background-order
                                          {:background-id bg-id
                                           :direction     :up
                                           :plan-id       plan-id
                                           :building-id   resolved-building-id
                                           :level-id      level-id}]))}
               [icon :chevron-down]]]
             [:span {:style {:flex 1 :font-size "12px" :overflow "hidden"
                             :text-overflow "ellipsis" :white-space "nowrap"}}
              layer-name]
             (cond
               is-front? [:span.badge.bg-primary {:style {:font-size "9px"}} "front"]
               is-back?  [:span.badge.bg-secondary {:style {:font-size "9px"}} "back"])]))])
     [:div.mt-3
      [background-image-editor plan-id building-id level-id open?-atom]]]))